import styled from "@emotion/styled";
import { timelineColors } from "../../../theme/config";

export const ExtendButtonWrapper = styled.div`
  position: absolute;
  bottom: 0;
  top: 0;
  display: flex;
  cursor: ew-resize;
  align-items: center;
  justify-content: center;

  &.right-0 {
    right: 0;
  }
`;

export const InnerExtendHandle = styled.div`
  height: 100%; /* for h-full */
  width: 100%; /* for w-full */
  font-size: 0.75rem;
`;

export const InnerSimplePreview = styled.div`
  margin-left: -4px; /* for ml-[-4px] */
  height: 0.75rem; /* for h-3 (Tailwind's h-3 is 12px = 0.75rem) */
  width: 0.75rem; /* for w-3 (Tailwind's w-3 is 12px = 0.75rem) */
  flex-shrink: 0; /* for shrink-0 */
  border-radius: 9999px; /* for rounded-full (Tailwind uses a large value for full rounding) */
`;

export const SimplePreviewWrapper = styled.div`
  color: white; /* for text-white */
  display: flex;
  height: 100%; /* for h-full */
  width: 100%; /* for w-full */
  flex-wrap: nowrap; /* for flex-nowrap */
  align-items: center; /* for items-center */
  gap: 0.5rem; /* for space-x-2 (Tailwind's space-x-2 is 8px = 0.5rem) */
  padding-left: 1rem; /* for px-4 (1rem = 16px) */
  padding-right: 1rem;
  background: #ff9843;
`;

export const TimelineItemWrapper = styled.div<{ isSelected: boolean }>`
  position: absolute;
  box-sizing: border-box;
  cursor: pointer;
  user-select: none;
  border-radius: 0.35rem;
  overflow: hidden;
  font-family: Poppins, sans-serif;
  font-weight: 500;
  outline: ${(props) =>
    props.isSelected ? `2px solid ${timelineColors.accent}` : "none"};
`;
